// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_Wo7BI","secondaryColumnCell":"secondary-column-cell_Wo7BI","root":"root_HiCPT","block":"block_ewNP6","item":"item_xD51a"};